import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { ConsumoTotem } from "../api"

export type VistaTotemPedidos =
    | "VIEW_ATRACAO"
    | "VIEW_CONSUMO"
    | "VIEW_CATALOGO"
    | "VIEW_CARRINHO"
    | "VIEW_FINALIZAR"
    | "VIEW_CONFIRMADO"

export interface TotemPedidosState {
    currentView: VistaTotemPedidos
    consumo: ConsumoTotem | null
    pedidoId: string | null
    passoFinalizar: number
}

const estadoInicial: TotemPedidosState = {
    currentView: "VIEW_ATRACAO",
    consumo: null,
    pedidoId: null,
    passoFinalizar: 0,
}

const totemPedidosSlice = createSlice({
    name: "totemPedidos",
    initialState: estadoInicial,
    reducers: {
        atualizarTotemPedidos(state, action: PayloadAction<Partial<TotemPedidosState>>) {
            return { ...state, ...action.payload }
        },
        resetarTotemPedidos() {
            return estadoInicial
        },
    },
})

export const { atualizarTotemPedidos, resetarTotemPedidos } = totemPedidosSlice.actions
export default totemPedidosSlice.reducer
